<template>
  <div class="timelineDivider">
    <div class="timelineCircle" />
    <div class="timelineCircle" />
    <div class="timelineCircle" />
    <div class="timelineCircle" />
    <div class="timelineCircle" />
    <div class="timelineCircle" />
    <div class="timelineCircle" />
  </div>
</template>

<script>
export default {
  name: "TimelineDivider"
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.timelineDivider {
  width: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timelineCircle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba($activeColor, 0.4);
  margin: 4px 0;

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }
}
</style>
